import React, { useState } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';

import Rs2 from '../../../assets/images/rrc/rs22.PNG';
import Yugto from '../../../assets/images/rrc/gallery/yugto/poster.jpg';
import BlogImg1 from '../../../assets/images/rrc/tournament/bday.png';
import BlogImg2 from '../../../assets/images/rrc/tournament/resbak.jpg';
import BlogImg3 from '../../../assets/images/rrc/tournament/una.jpg';
import BlogDetailsMain from '../event-details/BlogDetailsMain'; // ← adjust path if needed

const blogPosts = [
  { id: 0, title: 'RESBAK 2.0', image: Rs2, date: 'Nov 30, 2025', author: 'admin', animationDelay: '100ms', animationClass: 'fadeInLeft' },
  { id: 1, title: 'YUGTO', image: Yugto, date: 'May 31, 2025', author: 'admin', animationDelay: '200ms', animationClass: 'fadeInLeft' },
  { id: 2, title: 'Birthday Tournament', image: BlogImg1, date: 'February 9, 2025', author: 'admin', animationDelay: '300ms', animationClass: 'fadeInLeft' },
  { id: 3, title: 'Resbak', image: BlogImg2, date: 'November 30, 2024', author: 'admin', animationDelay: '400ms', animationClass: 'fadeInLeft' },
  { id: 4, title: 'Let The Riot Begin', image: BlogImg3, date: 'July 28, 2024', author: 'admin', animationDelay: '500ms', animationClass: 'fadeInLeft' }
];

export default function BlogOne() {
  const [open, setOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  const openModal = (post) => { setSelectedPost(post); setOpen(true); };
  const closeModal = () => setOpen(false);

  return (
    <section id='th-blog' className="blog-one">
      <div className="container">
        <div className="blog-one__top">
          <div className="section-title text-left">
            <div className="section-title__tagline-box">
              <span className="section-title__tagline">Events</span>
            </div>
            <h2 className="section-title__title">What We've Done</h2>
          </div>
        </div>

        <div className="blog-one__bottom">
          <div className="row">
            {blogPosts.map(post => (
              <div key={post.id} className={`col-xl-3 col-lg-3 col-md-3 wow ${post.animationClass}`} data-wow-delay={post.animationDelay}>
                <div className="blog-one__single" style={{ display:'flex', flexDirection:'column', height:'100%', background:'#000', borderRadius:'10px', overflow:'hidden' }}>
                  <button
                    type="button"
                    className="p-0 border-0 bg-transparent text-start w-100"
                    onClick={() => openModal(post)}
                    aria-label={`Open ${post.title}`}
                  >
                    <div className="blog-one__img" style={{ width:'100%', height:'400px', overflow:'hidden', borderRadius:'10px' }}>
                      <img src={post.image} alt={post.title} style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />
                    </div>
                  </button>

                  <div className="blog-one__content" style={{ width:'100%' }}>
                    <ul className="blog-one__meta list-unstyled">
                      <li><span className="icon-user"></span> By {post.author}</li>
                      <li><span className="icon-calendar"></span> {post.date}</li>
                    </ul>

                    <h3 className="blog-one__title">
                      <button type="button" className="bg-transparent border-0 p-0 text-white" onClick={() => openModal(post)}>
                        {post.title}
                      </button>
                    </h3>

                    <div className="blog-one__btn-box-two">
                      <button type="button" className="btn blog-one__btn thm-btn" onClick={() => openModal(post)}>
                        Read More <span className="icon-arrow-right"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* React-Responsive-Modal */}
      <Modal
        open={open}
        onClose={closeModal}
        center
        focusTrapped
        classNames={{ modal: 'bg-dark text-white' }}
        styles={{
          modal: { maxWidth: '1200px', width: '90vw', maxHeight: '90vh', overflow: 'auto' }
        }}
      >
        {selectedPost && <BlogDetailsMain post={selectedPost} />}
      </Modal>
    </section>
  );
}
